
import { Component, Vue, Prop } from 'vue-property-decorator';
import stores from '@/stores';
import { SweetModal } from 'sweet-modal-vue';
import {showToaster} from "@/components/DashboardComposer/helpers";
import { bus } from '@/helpers/functions';

@Component({
 components: {
   SweetModal,
 },
})

export default class CreateCategory extends Vue {
  @Prop({default: false})
  emitCreated!: boolean;

  newItem = {
    name: '',
    active: true,
    imageId: null,
    sort: null,
    territoryCode: '',
    shortCode: '',
    localCode: '',
  };

  nameRules = {
    required: true
  };
  submitNewItem() {
    if (this.newItem) {
        // @ts-ignore
      return stores.Language.createNewItem!((this.newItem))
        .then((response: any) => {
          if(response.type && response.type == 'error'){
            showToaster('danger', 'Error', response.messages[0],response.code);
            return;
          }
      bus().$emit('logged');
          this.cancel();
          if (this.emitCreated) {
            this.$emit('created', response.data);
            return;
          }
          this.$router.push({name: 'languages.show', params: {id: response.data.id}});
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  }
  cancel() {
    (document.getElementById('create-lang-form') as HTMLFormElement).classList.remove('was-validated');
    // @ts-ignore
    this.$children[0].close();
  }
  updateLocalCode() {
    this.newItem.territoryCode = this.newItem.territoryCode.toUpperCase();
    this.newItem.localCode = this.newItem.shortCode + '_' + this.newItem.territoryCode;
  }
  mounted() {

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const form = document.getElementById('create-lang-form')! as HTMLFormElement;
    form.addEventListener('submit', (event: any) => {
      event.preventDefault();
      if (form.checkValidity()) {
        event.stopPropagation();
        this.submitNewItem();
      }
      if (!form.checkValidity()) {
        event.stopPropagation();
      }
      form.classList.add('was-validated');

    }, false);
  }
}
